const DEFAULT_PER_PAGE = 5;

interface BuildPostSearchParamsArgs {
  query?: string | null;
  page: number | string;
  perPage?: number;
  selectedTagFilters: string[];
  categoryTags: string[];
  contentTagsMatch: 'any' | 'all';
  audience?: string;
  authorIds?: string[];
}

/**
 * Builds URLSearchParams for post fetching, used by all pagination/filtering
 * callbacks in usePaginatedPosts.
 */
const buildPostSearchParams = ({
  query,
  page,
  perPage,
  selectedTagFilters,
  categoryTags,
  contentTagsMatch,
  audience,
  authorIds,
}: BuildPostSearchParamsArgs): URLSearchParams => {
  const searchParams = new URLSearchParams();

  if (query?.trim()) {
    searchParams.append('q', query);
  }

  searchParams.append('page', page.toString());
  searchParams.append('per_page', (typeof perPage === 'number' && perPage > 0 ? perPage : DEFAULT_PER_PAGE).toString());

  const tagsToSend = selectedTagFilters.length > 0 ? selectedTagFilters : categoryTags;
  if (tagsToSend.length > 0) {
    for (const tag of tagsToSend) {
      searchParams.append('tags', tag);
    }
  }

  if (contentTagsMatch === 'all') {
    searchParams.append('content_tags_match', 'all');
  }

  if (audience && audience !== 'all') {
    searchParams.append('audience', audience);
  }

  if (authorIds && authorIds.length > 0) {
    for (const id of authorIds) {
      searchParams.append('author_ids[]', id);
    }
  }

  return searchParams;
};

export { DEFAULT_PER_PAGE };
export default buildPostSearchParams;
